/* =========================================================================
   LANGX for 英検® — 紹介特典 自動カート追加スクリプト（Shopify Horizon用）
   -------------------------------------------------------------------------
   動作:
   1. URLに ?ref=CODE が付いていたら sessionStorage に保存（回遊しても保持）
   2. カート内に「特典対象商品（2回・3回パック）」があり、ref があれば
      対応する特典商品（¥0）を自動でカートに追加
   3. 本体商品が無くなったら特典も自動で削除
   4. ref をカート属性に保存 → 注文データに載り、Webhookで代理店を計上

   設置場所: Shopify管理画面 → オンラインストア → テーマ → コードを編集
             → layout/theme.liquid の </body> 直前に
             <script src="{{ 'auto-gift.js' | asset_url }}" defer></script>
             （assets/auto-gift.js としてこのファイルをアップロード）

   関連する仕組み（このファイルの外）:
   ・特典商品には Shopify 管理画面で次のタグを付けること
       qty-fixed-1 … snippets/quantity-selector.liquid が数量セレクタを
                      hidden input に置き換える
       no-remove   … snippets/cart-products.liquid が削除ボタンを隠す
     どちらも顧客が特典行を操作して 特典欠落 の注文を作るのを防ぐためのもの。
     商品を作り直したときにタグを付け忘れると静かに壊れるので注意。
   ========================================================================= */

(function () {
  'use strict';

  /* ====================== ここだけ書き換えて使う ====================== */

  // 特典対象の本体商品 → 付与する特典商品 の対応表
  // キー: 本体のバリアントID / 値: { gift: 特典バリアントID, qty: 追加数 }
  // ※バリアントIDは 商品編集画面のURL末尾、または /products/xxx.js で確認できます
  const GIFT_RULES = {
    // ---- 3級 ----
    '48157328638110': { gift: '48169984950430', qty: 1 }, // 3級 2回パック → 特典1回(3級)
    '48157372874910': { gift: '48169984950430', qty: 1 }, // 3級 3回パック → 特典1回(3級)
    // ---- 準2級 ----
    '48157328670878': { gift: '48169984950430', qty: 1 },
    '48157372907678': { gift: '48169984950430', qty: 1 },
    // ---- 2級 ----
    '48157328703646': { gift: '48169984950430', qty: 1 },
    '48157372940446': { gift: '48169984950430', qty: 1 },
  };

  // 特典商品のバリアントID一覧（削除判定に使う。GIFT_RULESのgift値を列挙）
  const GIFT_VARIANTS = ['48169984950430'];

  // 紹介コードの形式チェック（例: WK-1234-A ＝ 英字2 - 数字4 - 英字1）
  const REF_PATTERN = /^[A-Z]{2}-[0-9]{4}-[A-Z]$/;

  const STORAGE_KEY = 'langx_ref_code';
  const DEBUG = true; // 検証中はtrue。本番ではfalse推奨

  // 紹介コード適用中に全ページ上部へ表示するバナー
  const BANNER_TEXT = '【限定特典】2回パック以上のご購入で、1回分を無料プレゼント';
  const BANNER_BG = '#DA2126'; // 英検レッド
  const BANNER_COLOR = '#FFFFFF';

  /* =================== ここから下は原則変更不要 =================== */

  const log = (...args) => DEBUG && console.log('[auto-gift]', ...args);

  // 追加失敗が続いた場合に無限ループを止めるためのガード
  let failureCount = 0;
  const MAX_FAILURES = 3;

  // 自分がカートAPIを叩いている間は true。fetch監視の自己検知を防ぐ
  let internalRequest = false;

  // --- 1. URLパラメータから ref を取得して保存 ---
  // sessionStorage はタブ単位で、タブを閉じると消える。
  // 一方カートはサーバー側に残るため、そのままだと
  //   ・カートに入れて後日また来た
  //   ・別タブでストアを開き直した
  // という保護者の特典が (a-2) で削除され、referral_code だけが残った
  // 状態、つまり検証フラグ 特典欠落 の注文になってしまう。
  // カート属性に保存済みの referral_code から復元してこれを防ぐ。
  async function captureRef() {
    const params = new URLSearchParams(window.location.search);
    const ref = (params.get('ref') || '').trim().toUpperCase();
    if (ref && REF_PATTERN.test(ref)) {
      sessionStorage.setItem(STORAGE_KEY, ref);
      log('ref を保存:', ref);
      return ref;
    }

    const stored = sessionStorage.getItem(STORAGE_KEY);
    if (stored) return stored;

    try {
      const cart = await getCart();
      const saved = (cart.attributes?.referral_code || '').trim().toUpperCase();
      if (saved && REF_PATTERN.test(saved)) {
        sessionStorage.setItem(STORAGE_KEY, saved);
        log('カート属性から ref を復元:', saved);
        return saved;
      }
    } catch (e) {
      log('ref の復元に失敗:', e);
    }
    return null;
  }

  // --- 1-2. 紹介コード適用中のバナーを表示 ---
  // 全ページの最上部（アナウンスバーの下）に表示する。
  // ref が保持されている間だけ表示され、無効化されると自動で消える。
  function renderRefBanner() {
    const ref = sessionStorage.getItem(STORAGE_KEY);
    const existing = document.getElementById('auto-gift-banner');

    if (!ref) {
      existing?.remove();
      return;
    }
    if (existing) return; // すでに表示済み

    const banner = document.createElement('div');
    banner.id = 'auto-gift-banner';
    banner.setAttribute('role', 'status');
    banner.textContent = BANNER_TEXT;
    banner.style.cssText = [
      'background:' + BANNER_BG,
      'color:' + BANNER_COLOR,
      'font-size:13px',
      'font-weight:700',
      'line-height:1.5',
      'text-align:center',
      'padding:10px 16px',
      'width:100%',
      'box-sizing:border-box',
      'position:relative',
      'z-index:5',
    ].join(';');

    // アナウンスバー（予約販売期間の帯）の直後に差し込む。
    // 将来アナウンスバーを削除・非表示にしても動くよう、
    //   1) 表示中のアナウンスバーの直後
    //   2) ヘッダーの直前
    //   3) body の先頭
    // の順にフォールバックする。
    const isVisible = (el) => {
      if (!el || !el.parentNode) return false;
      const style = window.getComputedStyle(el);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      return el.getBoundingClientRect().height > 0;
    };

    const announcement = [
      ...document.querySelectorAll(
        '[id*="header_announcements"], .announcement-bar, [class*="announcement"]'
      ),
    ].find(isVisible);
    const header = document.querySelector('header, [id*="header_section"]');

    if (announcement) {
      announcement.insertAdjacentElement('afterend', banner);
    } else if (header?.parentNode) {
      header.insertAdjacentElement('beforebegin', banner);
    } else {
      document.body.prepend(banner);
    }
    log('紹介コードバナーを表示しました:', ref);
  }

  // --- 共通: カート取得 ---
  async function getCart() {
    const res = await fetch(window.Shopify.routes.root + 'cart.js', {
      headers: { Accept: 'application/json' },
    });
    return res.json();
  }

  // --- 共通: カート属性に ref を保存（注文データに載せる） ---
  async function saveRefAttribute(ref) {
    await fetch(window.Shopify.routes.root + 'cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: { referral_code: ref } }),
    });
    log('カート属性に ref を保存:', ref);
  }

  // --- 共通: 商品追加 ---
  async function addItem(variantId, quantity) {
    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [
          {
            id: Number(variantId),
            quantity: quantity,
            // 特典であることを注文データに残す（Webhookでの判定用）
            properties: { _auto_gift: 'true' },
          },
        ],
      }),
    });
    if (!res.ok) {
      failureCount++;
      log(
        `追加に失敗 (${failureCount}/${MAX_FAILURES}):`,
        await res.text()
      );
      if (failureCount >= MAX_FAILURES) {
        log(
          '追加に繰り返し失敗したため停止します。特典商品のバリアントID・公開設定・在庫設定を確認してください。'
        );
      }
    }
    return res.ok;
  }

  // --- 共通: 行削除（keyベースが確実） ---
  async function removeItemByKey(key) {
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: 0 }),
    });
    log('特典を削除:', key);
  }

  // --- 共通: 数量変更 ---
  async function changeQuantityByKey(key, quantity) {
    await fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity }),
    });
    log('特典の数量を調整:', key, '→', quantity);
  }

  // --- 2. メイン処理 ---
  // allowAdd = true  : 商品がカートに追加された直後のみ。特典を追加する
  // allowAdd = false : それ以外（削除・数量変更・巡回）。特典の削除・調整のみ行う
  //   → ユーザーがカートを空にした直後に特典が復活するのを防ぐため
  let running = false;
  let pendingAdd = false; // 実行中に来た「追加」要求を取りこぼさない
  let currentAllowAdd = false; // 実行中の同期が追加を許可しているか
  async function syncGift(allowAdd = false) {
    if (failureCount >= MAX_FAILURES) return; // 連続失敗時は停止
    if (running) {
      // 実行中の同期が「調整のみ」なら、追加要求を記憶して後で再実行する
      if (allowAdd && !currentAllowAdd) pendingAdd = true;
      return;
    }
    running = true;
    currentAllowAdd = allowAdd; // 実行中の同期が追加を許可しているか
    internalRequest = true; // これ以降の自分のカート操作は監視対象外にする
    let needsRefresh = false;
    try {
      const ref = sessionStorage.getItem(STORAGE_KEY);
      const cart = await getCart();

      // カート内の特典行 / 本体行を仕分け
      const allGiftLines = cart.items.filter((i) =>
        GIFT_VARIANTS.includes(String(i.variant_id))
      );
      // このスクリプトが追加した行だけを正規の特典として扱う。
      // properties._auto_gift が無い行 = 顧客が商品ページから手動で入れた行。
      const giftLines = allGiftLines.filter(
        (i) => i.properties && i.properties._auto_gift === 'true'
      );
      const manualGiftLines = allGiftLines.filter(
        (i) => !(i.properties && i.properties._auto_gift === 'true')
      );
      const eligible = cart.items.filter(
        (i) => GIFT_RULES[String(i.variant_id)] !== undefined
      );

      let changed = false;

      // (a-1) 手動で追加された特典は常に削除（単体購入・不正取得の防止）
      for (const line of manualGiftLines) {
        await removeItemByKey(line.key);
        log('手動追加された特典を削除しました:', line.title);
        changed = true;
      }

      // (a-2) ref が無い or 対象商品が無い → 正規の特典も削除
      if (!ref || eligible.length === 0) {
        for (const line of giftLines) {
          await removeItemByKey(line.key);
          changed = true;
        }
        needsRefresh = changed;
        return;
      }

      // (b) 必要な特典数を集計
      const needed = {};
      for (const line of eligible) {
        const rule = GIFT_RULES[String(line.variant_id)];
        needed[rule.gift] = (needed[rule.gift] || 0) + rule.qty * line.quantity;
      }

      // (c) 不足分を追加（カート追加直後のみ）
      if (allowAdd) {
        for (const [giftId, qty] of Object.entries(needed)) {
          const current = giftLines
            .filter((l) => String(l.variant_id) === giftId)
            .reduce((s, l) => s + l.quantity, 0);
          if (current < qty) {
            await addItem(giftId, qty - current);
            changed = true;
          }
        }
      }

      // (d) 余分な特典を削除（本体を減らした場合など。常に実行）
      for (const line of giftLines) {
        const want = needed[String(line.variant_id)] || 0;
        if (want === 0) {
          await removeItemByKey(line.key);
          changed = true;
        } else if (line.quantity > want) {
          await changeQuantityByKey(line.key, want);
          changed = true;
        }
      }

      // (e) ref をカート属性に保存
      if (cart.attributes?.referral_code !== ref) {
        await saveRefAttribute(ref);
        changed = true;
      }

      needsRefresh = changed;
    } catch (e) {
      log('エラー:', e);
    } finally {
      running = false;
      currentAllowAdd = false;
      internalRequest = false;
      renderRefBanner(); // ref の状態に応じてバナーを出し入れ
      // カートを変更した場合のみ、テーマに再描画を依頼する
      if (needsRefresh) refreshCartUI();
      // 実行中に来た追加要求を処理する
      if (pendingAdd) {
        pendingAdd = false;
        setTimeout(() => syncGift(true), 300);
      }
    }
  }

  // --- 3. カートUIの更新 ---
  // 自分でDOMを差し替えず、Shopify標準イベントで通知してテーマ自身に
  // morphSection で安全に再描画させる。
  //
  // 実ストア(/cdn/shop/t/3/assets/cart-icon.js)と
  // https://cdn.shopify.com/storefront/standard-events.js を確認した結果:
  //   ・イベント名は "shopify:cart:lines-update"
  //   ・購読側は event.promise を待ち {cart, detail} を受け取る
  //   ・cart は Storefront API 形式（totalQuantity など）である必要がある
  //     → 変換関数 CartLinesUpdateEvent.createCartFromAjaxResponse が公開されている
  const STANDARD_EVENTS_URL = 'https://cdn.shopify.com/storefront/standard-events.js';
  let standardEventsModule = null;

  async function loadStandardEvents() {
    if (standardEventsModule) return standardEventsModule;
    try {
      standardEventsModule = await import(STANDARD_EVENTS_URL);
    } catch (e) {
      log('標準イベントモジュールの読み込みに失敗:', e);
    }
    return standardEventsModule;
  }

  async function refreshCartUI() {
    try {
      // 画面上のカートセクションIDを集め、更新後のHTMLも一緒に取得する
      const sectionIds = [
        ...new Set(
          [...document.querySelectorAll('[data-section-id]')]
            .filter((el) => /cart/i.test(el.tagName))
            .map((el) => el.dataset.sectionId)
            .filter(Boolean)
        ),
      ];

      const res = await fetch(
        window.Shopify.routes.root +
          'cart.js' +
          (sectionIds.length
            ? '?sections=' + encodeURIComponent(sectionIds.join(','))
            : ''),
        { headers: { Accept: 'application/json' } }
      );
      const cartJson = await res.json();

      const mod = await loadStandardEvents();
      if (!mod?.CartLinesUpdateEvent) {
        log('標準イベントが使えないため通知をスキップしました');
        return;
      }

      const { CartLinesUpdateEvent } = mod;
      const { promise, resolve } = CartLinesUpdateEvent.createPromise();

      // Ajax形式のカートを Storefront API 形式に変換（公式ヘルパーを使用）
      const cart = CartLinesUpdateEvent.createCartFromAjaxResponse(cartJson);

      const event = new CartLinesUpdateEvent({
        action: 'add',
        source: 'auto-gift',
        lines: [],
        promise,
      });
      document.dispatchEvent(event);

      // 購読側（cart-icon / cart-items-component）はこの解決を待って描画する
      resolve({
        cart,
        detail: {
          itemCount: cartJson.item_count,
          source: 'auto-gift',
          sections: cartJson.sections,
        },
        sections: cartJson.sections,
      });

      log('テーマにカート更新を通知しました (商品数:', cartJson.item_count, ')');
    } catch (e) {
      log('UI更新の通知に失敗:', e);
    }
  }

  // --- 4. 起動 & カート変更の監視 ---
  // Horizonはweb components構造で、カート追加の実装がテーマ更新で変わりうる。
  // 取りこぼしを防ぐため、4系統の検知を併用する。
  //
  // captureRef が非同期になったので await を付けること。
  // 付けないと ref の復元前に syncGift が走り、(a-2) が特典を消してしまう。
  async function init() {
    await captureRef();
    renderRefBanner();
    syncGift();

    // allowAdd=true は「商品がカートに追加された」ときだけ。
    // 削除・数量変更・巡回では特典を追加しない（空にした直後の復活を防ぐ）
    const trigger = (why, allowAdd = false) => {
      log('カート変更を検知:', why, allowAdd ? '(追加あり)' : '(調整のみ)');
      // Shopify側でカートに反映されるまで少し待つ
      setTimeout(() => syncGift(allowAdd), 800);
    };

    // (1) Shopify標準のカートイベントを購読
    //     CartLinesUpdateEvent は action ('add' | 'update' | 'remove' 等) を持つので
    //     それで「追加された」かどうかを正確に判定できる。
    //     自分が発火したイベント（source: 'auto-gift'）は無視してループを防ぐ。
    document.addEventListener('shopify:cart:lines-update', (e) => {
      if (e?.source === 'auto-gift' || e?.detail?.source === 'auto-gift') return;
      const action = e?.action || e?.detail?.action;
      const isAdd = action === 'add';
      // テーマ側のカート反映を待ってから同期する
      if (e?.promise?.then) {
        e.promise
          .then(() => trigger('event:lines-update(' + action + ')', isAdd))
          .catch(() => {});
      } else {
        trigger('event:lines-update(' + action + ')', isAdd);
      }
    });

    // (2) fetch を監視（多くのテーマ・アプリはこれを使う）
    //     /cart/add.js のときだけ特典追加を許可する
    const originalFetch = window.fetch;
    window.fetch = async function (...args) {
      const response = await originalFetch.apply(this, args);
      try {
        const url = typeof args[0] === 'string' ? args[0] : args[0]?.url || '';
        if (internalRequest) return response; // 自分の操作は無視（ループ防止）
        if (/\/cart\/add/.test(url)) {
          trigger('fetch:' + url, true); // 追加操作 → 特典を付与
        } else if (/\/cart\/(change|update)/.test(url)) {
          trigger('fetch:' + url, false); // 削除・数量変更 → 調整のみ
        }
      } catch (e) {}
      return response;
    };

    // (3) XMLHttpRequest を監視（fetch を使わない実装への保険）
    const originalOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function (method, url, ...rest) {
      this.addEventListener('load', function () {
        try {
          const u = String(url);
          if (/\/cart\/add/.test(u)) {
            trigger('xhr:' + u, true);
          } else if (/\/cart\/(change|update)/.test(u)) {
            trigger('xhr:' + u, false);
          }
        } catch (e) {}
      });
      return originalOpen.call(this, method, url, ...rest);
    };

    // ポーリングは廃止（fetch/XHR監視で確実に検知できているため）
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();